import {
  LayoutDashboard,
  MapPin,
  Users,
  ChefHat,
  CircleHelp,
  Headphones,
  Building,
  ShieldCheck,
  ScrollText,
  List,
  Globe,
  Building2,
  ReceiptText,
  ClipboardList,
  ClipboardCheck,
  Wrench,
  Archive,
  UtensilsCrossed,
} from "lucide-react";
import { msg } from "@lingui/core/macro";
import { createNavMenu } from "@/lib/nav-builder";

// ---------------------------------------------------------------------------
// Nav definition — driven by permissions and section-level role constraints
// msg`` descriptors let Lingui extract strings statically at build time
// ---------------------------------------------------------------------------

export const NAV = createNavMenu()
  .addSection(msg`Main`)
    .addItem({ title: msg`Dashboard`, url: "/dashboard", icon: LayoutDashboard })
    // Prep and service are two boards, not one (T-1105): prep is what the
    // kitchen queued for itself, service is what the tickets asked for. They
    // shared a list, and during service that meant tomorrow's prep sitting
    // between live orders.
    .addItem({ title: msg`Prep`,      url: "/prep",      icon: ClipboardCheck, permission: "cooking-session:read", modes: ["working"] })
    .addItem({ title: msg`Service`,   url: "/working",   icon: ChefHat,       permission: "cooking-session:read", modes: ["working"] })
    .addItem({ title: msg`Recipes`,   url: "/recipes",   icon: List,          permission: "recipe:read",          modes: ["build"] })
    .addItem({ title: msg`Menu Items`, url: "/menus",    icon: UtensilsCrossed, permission: "menu:read",      modes: ["build"] })
    .addItem({ title: msg`Equipment`, url: "/equipment", icon: Archive,       permission: "recipe:read",          modes: ["build"] })
    // Tickets are opt-in per organization (T-1106) — a kitchen that only preps
    // has no use for either of these, and the API refuses them anyway.
    .addItem({ title: msg`New Order`, url: "/new-order", icon: ReceiptText,   permission: "order:create",         badge: "NEW",  modes: ["working"], feature: "kdsOrders" })
    .addItem({ title: msg`Orders`,    url: "/orders",    icon: ClipboardList, permission: "order:read",           badge: "LIVE", modes: ["working"], feature: "kdsOrders" })
  // Concepts stays a leaf on purpose: it has no children, and clicking it goes
  // straight to the concept list.
  .addSection(msg`Organization`, { modes: ["build"], requiresOrgContext: true })
    .addItem({ title: msg`Concepts`, url: "/companies", icon: Building, permission: "company:read" })
    .addItem({
      title: msg`Locations`,
      icon: MapPin,
      items: [
        { title: msg`Regions`,   url: "/regions",   icon: Globe,  permission: "region:read" },
        { title: msg`Locations`, url: "/locations", icon: MapPin, permission: "location:read" },
      ],
    })
    .addItem({
      title: msg`User Management`,
      icon: Users,
      items: [
        { title: msg`Users`, url: "/users", icon: Users,       permission: "user:read" },
        { title: msg`Roles`, url: "/roles", icon: ShieldCheck, permission: "role:read" },
      ],
    })
  .addSection(msg`Yes, Chef! Internal`, { internal: true, rolesAny: ["SUPER_ADMIN", "SUPPORT"] })
    .addItem({ title: msg`Organizations`, url: "/organizations", icon: Building2 })
    .addItem({ title: msg`Concepts`,     url: "/companies",     icon: Building,    permission: "company:read" })
    .addItem({ title: msg`Locations`,     url: "/locations",     icon: MapPin,      permission: "location:read" })
    .addItem({ title: msg`Users`,         url: "/users",         icon: Users,       permission: "user:read" })
    .addItem({ title: msg`Permissions`,   url: "/rolesperms",    icon: ShieldCheck, permission: "role:read" })
    .addItem({ title: msg`Audit Logs`,    url: "/admin/audit",   icon: ScrollText,  permission: "role:read" })
  .addSection(msg`Support`, { internal: true, rolesAny: ["SUPER_ADMIN", "SUPPORT"] })
    .addItem({ title: msg`Cleanup`, url: "/support/cleanup", icon: Wrench })
  .addSection(msg`Help`)
    .addItem({ title: msg`Help center`, url: "#", icon: CircleHelp, external: true })
    .addItem({ title: msg`Contact`,     icon: Headphones, action: "support-chat" })
  .build();
